import Moment, {isDate} from "moment";

export function parseDateString(value, originalValue) {
  return originalValue === '' || originalValue === null || originalValue === undefined ? null : (
      isDate(originalValue) 
          ? originalValue 
          : new Date (Date.parse(`${Moment(originalValue, ["yyyy-MM-DD", "DD/MM/yyyy"]).hours(+1).toISOString().substring(0,19)}`.concat("+00:00")))
  );
}
